/**
 * עיצוב תצוגה. אחסון ב־UTC, תצוגה ב־Asia/Jerusalem (A-08).
 * מועד שאינו ידוע מוצג כ״לא ידוע״ — לא כתאריך ריק ולא כתאריך של היום.
 */

import type { ObservedAtSource, Timestamp } from './types.ts';

const DISPLAY_TIME_ZONE = 'Asia/Jerusalem';

export const UNKNOWN_TEXT = 'לא ידוע';

export function formatDate(value: Timestamp | null): string {
  if (value === null) return UNKNOWN_TEXT;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return UNKNOWN_TEXT;
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: DISPLAY_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateTime(value: Timestamp | null): string {
  if (value === null) return UNKNOWN_TEXT;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return UNKNOWN_TEXT;
  const day = new Intl.DateTimeFormat('en-GB', {
    timeZone: DISPLAY_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
  const time = new Intl.DateTimeFormat('en-GB', {
    timeZone: DISPLAY_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
  return `${day} ${time}`;
}

/**
 * מועד תצפית מוצג תמיד עם מקורו — EXIF או שעון מכשיר אינם ראיה ודאית
 * (§10), ולכן אסור שייראו כעובדה מאומתת.
 */
export function formatObservedAt(value: Timestamp | null, source: ObservedAtSource): string {
  if (value === null || source === 'unknown') return UNKNOWN_TEXT;
  const sourceText = source === 'device' ? 'שעון המכשיר' : 'הוזן ידנית';
  return `${formatDateTime(value)} (${sourceText})`;
}

export function formatDuration(minutes: number | null): string {
  if (minutes === null) return UNKNOWN_TEXT;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} דקות`;
  if (rest === 0) return hours === 1 ? 'שעה' : `${hours} שעות`;
  return `${hours}:${String(rest).padStart(2, '0')} שעות`;
}
